export default {"src":"/_next/static/media/deer-valley.773bc234.svg","height":83,"width":216,"blurWidth":0,"blurHeight":0};